import type {
  Address,
  AddressVersion,
} from '@festina/legalentity-general-types/legalentity'

export const cleanupAddressVersion = (address: AddressVersion): Address => ({
  ...address,
  _type: 'Address',
})
